// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Defines translation status.
 * @class TranslationStatus
 */
export enum TranslationStatus {
    /**
     * @member TranslationStatus.Success
     */
    Success = 0,

    /**
     * @member TranslationStatus.Error
     */
    Error,
}
